import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';

import {connect} from 'react-redux';
import {compose} from 'redux';
import {injectIntl, intlShape, defineMessages} from 'react-intl';

import {closeUpdateModal} from '../reducers/modals';
import {setUpdate, clearUpdate} from '../reducers/update';

import UpdateModalComponent from '../components/update-modal/update-modal.jsx';
import MessageBoxType from '../lib/message-box.js';
import {UPDATE_MODAL_STATE} from '../lib/update-state.js';

const messages = defineMessages({
    updateWarning: {
        id: 'gui.updateModal.updateWarning',
        defaultMessage: 'Currently unsaved projects will be lost, continue update and restart?',
        description: 'Confirmation that user wants update'
    }
});

class UpdateModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCancel',
            'handleClickUpdate',
            'handleDontRemind'
        ]);
    }
    componentDidMount () {
        this.checkSuppression();
    }
    componentDidUpdate () {
        this.checkSuppression();
    }
    componentWillUnmount () {
        clearInterval(this.downloadInterval);
    }

    checkSuppression () {
        if (this.props.updateState &&
            this.props.updateState.phase === UPDATE_MODAL_STATE.resourceUpdateAvailable &&
            this.props.updateState.info &&
            this.props.updateState.info.isStartup) {
            const version = this.props.updateState.info.version || '';
            const dontRemindVer = localStorage.getItem('dontRemindAgentVersion');
            const dontRemindAll = localStorage.getItem('dontRemindAgentUpdate');
            if (dontRemindAll === 'true' || (dontRemindVer && dontRemindVer === version)) {
                this.handleCancel();
            }
        }
    }

    handleCancel () {
        this.props.onClearUpdate();
        this.props.onAbortUpdate();
    }

    handleDontRemind () {
        const version = this.props.updateState && this.props.updateState.info ?
            this.props.updateState.info.version : '';
        if (version) {
            localStorage.setItem('dontRemindAgentVersion', version);
        }
        localStorage.setItem('dontRemindAgentUpdate', 'true');
        this.handleCancel();
    }

    handleClickUpdate () {
        if (this.props.updateState && this.props.updateState.phase === UPDATE_MODAL_STATE.resourceUpdateAvailable) {
            const agentPageUrl = 'https://tifstudio.in/agent.html';
            if (typeof window !== 'undefined' && window.require) {
                try {
                    const {shell} = window.require('electron');
                    if (shell && shell.openExternal) {
                        shell.openExternal(agentPageUrl);
                    } else {
                        window.open(agentPageUrl, '_blank', 'noopener,noreferrer');
                    }
                } catch (_) {
                    window.open(agentPageUrl, '_blank', 'noopener,noreferrer');
                }
            } else if (typeof window !== 'undefined') {
                window.open(agentPageUrl, '_blank', 'noopener,noreferrer');
            }
            this.handleCancel();
            return;
        }

        const confirmUpdate = this.props.onShowMessageBox(MessageBoxType.confirm,
            this.props.intl.formatMessage(messages.updateWarning));
        if (confirmUpdate) {
            this.props.onSetUpdate({phase: 'downloading', speed: 0, transferred: 0});
            this.props.onClickUpdate();
        }
    }

    render () {
        return (
            <UpdateModalComponent
                intl={this.props.intl}
                onClickUpdate={this.handleClickUpdate}
                onCancel={this.handleCancel}
                onDontRemind={this.handleDontRemind}
                updateState={this.props.updateState}
            />
        );
    }
}

UpdateModal.propTypes = {
    intl: intlShape,
    onAbortUpdate: PropTypes.func.isRequired,
    onClickUpdate: PropTypes.func.isRequired,
    onClearUpdate: PropTypes.func.isRequired,
    onSetUpdate: PropTypes.func.isRequired,
    onShowMessageBox: PropTypes.func.isRequired,
    updateState: PropTypes.shape({
        phase: PropTypes.oneOf(Object.keys(UPDATE_MODAL_STATE)),
        info:
            PropTypes.shape({
                isStartup: PropTypes.bool,
                version: PropTypes.string,
                message: PropTypes.oneOf([PropTypes.object, PropTypes.string]),
                phase: PropTypes.string,
                progress: PropTypes.number,
                state: PropTypes.shape({
                    name: PropTypes.string,
                    speed: PropTypes.string,
                    total: PropTypes.string,
                    done: PropTypes.string
                })
            })
    })
};

const mapStateToProps = state => ({
    updateMessage: state.scratchGui.update.updateMessage,
    updateState: state.scratchGui.update.updateState
});

const mapDispatchToProps = dispatch => ({
    onClearUpdate: () => {
        dispatch(closeUpdateModal());
        dispatch(clearUpdate());
    },
    onSetUpdate: message => dispatch(setUpdate(message))
});

export default compose(
    injectIntl,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(UpdateModal);
